module.exports = __webpack_public_path__ + "static/tree-53a5c564a5529a596fa161078e2a5c81.png";